import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IConfiguration, ICompany } from '../../services/configuration';

interface ConfigurationState {
  configuration: IConfiguration | null;
  company: ICompany | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: ConfigurationState = {
  configuration: null,
  company: null,
  isLoading: false,
  error: null,
};

export const configurationSlice = createSlice({
  name: 'configuration',
  initialState,
  reducers: {
    setConfiguration: (state, action: PayloadAction<IConfiguration>) => {
      state.configuration = action.payload;
      state.error = null;
    },
    setCompany: (state, action: PayloadAction<ICompany>) => {
      state.company = action.payload;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearConfiguration: (state) => {
      state.configuration = null;
      state.company = null;
      state.error = null;
    },
  },
});

export const {
  setConfiguration,
  setCompany,
  setLoading,
  setError,
  clearConfiguration,
} = configurationSlice.actions;

export default configurationSlice.reducer; 